import {
  CONTENT_SECTOR_TYPE,
  ContentSectorDataType,
  ContentStoreDataType,
  ContentType,
  STORE_OPEN,
} from "../../../controller/MasterController";

// // 현재 시간과 오픈, 마감의 시간 차이
export const checkOpenClosingTime = (
  data: ContentStoreDataType,
  currentDate: Date
) => {
  const closeTime = Math.floor(
    new Date(data.next_close_time).getTime() / (1000 * 60)
  );
  const openTime = Math.floor(
    new Date(data.next_open_time).getTime() / (1000 * 60)
  );

  if (
    closeTime - Math.floor(currentDate.getTime() / (1000 * 60)) < 60 &&
    closeTime - Math.floor(currentDate.getTime() / (1000 * 60)) > 0
  )
    return {
      status: "close",
      time: closeTime - Math.floor(currentDate.getTime() / (1000 * 60)),
    };

  if (
    openTime - Math.floor(currentDate.getTime() / (1000 * 60)) < 60 &&
    openTime - Math.floor(currentDate.getTime() / (1000 * 60)) > 0
  )
    return {
      status: STORE_OPEN,
      time: openTime - Math.floor(currentDate.getTime() / (1000 * 60)),
    };
  return {
    status: "",
    time: 100,
  };
};

// // 그룹 안에서 오픈, 마감 시간 차이 계산
export const checkGroupedTime = (data: ContentType) => {
  const currentDate = new Date();

  if (data.content_type === CONTENT_SECTOR_TYPE) {
    let tempData = { status: "", time: 100 };
    (data.data as ContentSectorDataType).store_list.map(
      (item: ContentStoreDataType, index: number) => {
        const result = checkOpenClosingTime(item, currentDate);
        if (result.status === "close" && tempData.status !== "close")
          tempData = result;
        else {
          if (
            result.status === STORE_OPEN &&
            tempData.status !== "close" &&
            result.time < tempData.time
          )
            tempData = result;
          else if (result.status === "close" && result.time > tempData.time)
            tempData = result;
        }
      }
    );
    return tempData;
  } else {
    return checkOpenClosingTime(data.data as ContentStoreDataType, currentDate);
  }
};

export const checkCoupon = (data: ContentType) => {
  if (data.content_type === CONTENT_SECTOR_TYPE) {
    for (const item of (data.data as ContentSectorDataType).store_list) {
      // console.log("store", item.store_name, item.store_availability_yn);
      if (item.coupon_yn) return true;
    }
    return false;
  } else {
    return (data.data as ContentStoreDataType).coupon_yn;
  }
};

export const getCouponBadge = (data: ContentType) => {
  if (data.content_type === CONTENT_SECTOR_TYPE) {
    if ((data.data as ContentSectorDataType).store_list.length > 1)
      return "쿠폰";
    else
      return (data.data as ContentSectorDataType).store_list[0]
        .coupon_badge_name;
  } else {
    return (data.data as ContentStoreDataType).coupon_badge_name;
  }
};
